appSocial.component('spinner', {
    templateUrl: 'shared/components/spinner/SpinnerComponent.html',
    bindings: {
        trader: '<'
    },
    controller: class SpinnerComponent {
        constructor() {
        }
    }
})
